<template>
  <Container class="text-white">
    <p class="pb-8 pt-16 text-center text-2xl">
      {{ $t('form.variantSelection.title') }}
    </p>

    <div class="relative mb-5 flex items-center justify-center gap-4 overflow-hidden py-2 font-medium">
      <button
        type="button"
        class="group flex items-center justify-between rounded-full border border-white px-4 py-2 transition duration-150 md:px-6 md:py-3"
        :class="formVariant === FormVariant.SELF ? 'bg-white text-black' : 'bg-black text-white'"
        @click="setFormVariant(FormVariant.SELF)">
        {{ $t('form.variantSelection.self') }}
      </button>
      <button
        type="button"
        class="group flex items-center justify-between rounded-full border border-white px-4 py-2 transition duration-300 md:px-6 md:py-3"
        :class="formVariant === FormVariant.CHILD ? 'bg-white text-black' : 'bg-black text-white'"
        @click="setFormVariant(FormVariant.CHILD)">
        {{ $t('form.variantSelection.child') }}
      </button>
    </div>

    <Transition
      mode="out-in"
      @after-enter="el => el.scrollIntoView({ behavior: 'smooth' })">
      <SelfApplicationForm
        v-if="formVariant === FormVariant.SELF"
        :key="FormVariant.SELF + remountCount" />
      <ChildApplicationForm
        v-else-if="formVariant === FormVariant.CHILD"
        :key="FormVariant.CHILD + remountCount" />
    </Transition>
  </Container>
</template>

<script setup lang="ts">
  import { FormVariant } from '~/constants/form'

  const { formVariant, remountCount, setFormVariant } = useFormVariant()
</script>

<style scoped>
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.3s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
</style>
